import client from './httpClient';

export const offerViews = params => client.get('offerviews', { params }).then(({ data }) => data);

export const offerWishedCount = id => client.get(`offer-wished/${id}/count`).then(({ data }) => data);
